import { useState, useRef, useEffect } from "react";
import { api } from "../lib/api";
import { PageHead } from "../components/ui-bits";
import { PaperPlaneRight, Robot, User } from "@phosphor-icons/react";

const SUGGESTIONS = [
  "How much GST do I owe?",
  "Why did profit fall?",
  "Show pending receivables.",
  "What are this month's compliances?",
];

export default function AICfo() {
  const [messages, setMessages] = useState([
    { role: "ai", text: "Hello! I'm your Virtualeena AI Virtual CFO. Ask me anything about your finances, compliance or cash flow." },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [session, setSession] = useState(null);
  const endRef = useRef();

  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages, loading]);

  const send = async (text) => {
    const msg = (text || input).trim();
    if (!msg || loading) return;
    setMessages((m) => [...m, { role: "user", text: msg }]);
    setInput(""); setLoading(true);
    try {
      const { data } = await api.post("/ai/chat", { message: msg, session_id: session });
      setSession(data.session_id);
      setMessages((m) => [...m, { role: "ai", text: data.reply }]);
    } catch (e) {
      setMessages((m) => [...m, { role: "ai", text: "Sorry, I couldn't process that right now. Please try again." }]);
    } finally { setLoading(false); }
  };

  return (
    <div>
      <PageHead eyebrow="Ask Your Numbers" title="AI Virtual CFO" />
      <div className="card flex flex-col h-[calc(100vh-220px)]">
        <div className="flex-1 overflow-y-auto p-6 space-y-4">
          {messages.map((m, i) => (
            <div key={i} data-testid={`msg-${i}`} className={`flex gap-3 ${m.role === "user" ? "flex-row-reverse" : ""}`}>
              <div className={`w-8 h-8 shrink-0 rounded-sm flex items-center justify-center ${m.role === "user" ? "bg-[#111]" : "bg-[#002FA7]"} text-white`}>
                {m.role === "user" ? <User size={16} /> : <Robot size={16} weight="fill" />}
              </div>
              <div className={`max-w-[75%] px-4 py-2.5 text-sm rounded-sm ${m.role === "user" ? "bg-[#111] text-white" : "bg-black/[0.04] border border-black/10"}`}>
                {m.text.split("\n").map((l, j) => <p key={j} className={j ? "mt-1" : ""}>{l}</p>)}
              </div>
            </div>
          ))}
          {loading && <div className="flex gap-3"><div className="w-8 h-8 rounded-sm bg-[#002FA7] text-white flex items-center justify-center"><Robot size={16} weight="fill" /></div><div className="px-4 py-2.5 bg-black/[0.04] border border-black/10 text-sm text-[#888]">Thinking…</div></div>}
          <div ref={endRef} />
        </div>

        <div className="border-t border-black/10 p-4">
          <div className="flex flex-wrap gap-2 mb-3">
            {SUGGESTIONS.map((s) => (
              <button key={s} data-testid={`suggest-${s.slice(0,10)}`} onClick={() => send(s)}
                className="text-xs border border-black/15 rounded-sm px-2.5 py-1 hover:bg-black/5 transition-colors">{s}</button>
            ))}
          </div>
          <form onSubmit={(e) => { e.preventDefault(); send(); }} className="flex gap-2">
            <input data-testid="ai-input" value={input} onChange={(e) => setInput(e.target.value)} placeholder="Ask your Virtual CFO…"
              className="flex-1 border border-black/20 rounded-sm px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#002FA7]" />
            <button data-testid="ai-send" disabled={loading}
              className="bg-[#002FA7] hover:bg-[#00227A] text-white px-4 rounded-sm transition-colors disabled:opacity-50">
              <PaperPlaneRight size={18} weight="fill" />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
